module.exports = __webpack_public_path__ + "346d7394d2492433f16548d65483601b.pdf";